import { useStore as baseUseStore } from 'vuex';
import { storeKey } from '@/store';
import { GeoblockRuleListState } from './geoblockRuleList';

export const useStore = () => baseUseStore<{ geoblockRuleList: GeoblockRuleListState}>(storeKey);
